export default __webpack_public_path__ + "static/media/logo.2b4fe79d.png";